import { combineReducers } from "redux";
import socketReducer from "./socketSlice";
import checkOutConfirmInfoReducer from "./checkOutConfirmInfoSlice";
import {
  SET_OUT_OF_SERVICE,
  RESET_REDUX,
  SET_USER,
  SET_SELECTED_ROOM,
  SET_CURRENT_ROOM,
  SET_GUEST,
  CLEAN_ROOM_SELECTION,
  CLEAN_CURRENT_ROOM_SELECTION,
  CLEAN_GUEST_SELECTION,
  SET_CUSTOMER_INFO,
  SET_STAFF_INFO,
  SET_PAYMENT_INFO,
  CLEAN_PAYMENT_INFO,
  SET_PICKED_DATE,
} from "./action-types";

const initErrorState = {
  outOfService: false
};

const errorReducer = (state = initErrorState, action) => {
  switch (action.type) {
    case SET_OUT_OF_SERVICE:
      return { ...state, outOfService: action.data };
    default:
      return state;
  }
};

const initUserState = {
  user: {
    userId: "",
    fullName: "",
    phoneNumber: "",
    email: "",
  },
};

const userReducer = (state = initUserState, action) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.data };
    default:
      return state;
  }
};

const initSelectState = {
  currentRoom: null,
  selectedRoom: null,
  selectedGuest: null,
  modalIsOpen: false,
};

const selectReducer = (state = initSelectState, action) => {
  switch (action.type) {
    case SET_CURRENT_ROOM:
      return { ...state, currentRoom: action.data };
    case SET_GUEST:
      return { ...state, selectedGuest: action.data };
    case SET_SELECTED_ROOM:
      return { ...state, selectedRoom: action.data, modalIsOpen: !!action.data };
    case CLEAN_ROOM_SELECTION:
      return { ...state, selectedRoom: null, modalIsOpen: false };
    case CLEAN_CURRENT_ROOM_SELECTION:
      return { ...state, currentRoom: null };
    case CLEAN_GUEST_SELECTION:
      return { ...state, selectedGuest: null };
    default:
      return state;
  }
};

const initCustomerInfoState = {
  customerInfo: {
    tenantId: "",
    userId: "",
    fullName: "",
    organization: "",
    phoneNumber: "",
    email: "",
    streetAddress: "",
    streetAddressLine2: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
    dateOfBirth: "",
    travelDocumentNumber: "",
    travelDocumentType: "",
    isFirstNations: false,
    subscribedToMarketingEmails: false,
    subscribedToMarketingTexts: false,
  },
};

const customerInfoReducer = (state = initCustomerInfoState, action) => {
  switch (action.type) {
    case SET_CUSTOMER_INFO:
      return { ...state, customerInfo: { ...state.customerInfo, ...action.data }};
    default:
      return state;
  }
};

const initStaffInfoState = {
  staffInfo: {
    staffId: "",
    userId: "",
    fullName: "",
    phoneNumber: "",
    email: "",
    streetAddress: "",
    streetAddressLine2: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
    staffRoleIds: [],
    isActive: true,
  },
};

const staffInfoReducer = (state = initStaffInfoState, action) => {
  switch (action.type) {
    case SET_STAFF_INFO:
      return { ...state, staffInfo: { ...state.staffInfo, ...action.data } };
    default:
      return state;
  }
};

const initPaymentInfoState = {
  paymentInfo: {
    cardHolderName: "",
    creditCardNumber: "",
    cardExpirationDate: "",
    cardCVV: "",
    streetAddress: "",
    streetAddressLine2: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
  },
};

const paymentInfoReducer = (state = initPaymentInfoState, action) => {
  switch (action.type) {
    case SET_PAYMENT_INFO:
      return { ...state, paymentInfo: { ...state.paymentInfo, ...action.data } };
    case CLEAN_PAYMENT_INFO:
      return initPaymentInfoState;
    default:
      return state;
  }
};

const initPickedDateState = {
  pickedDate: Date.now(),
};

const pickedDateReducer = (state = initPickedDateState, action) => {
  switch (action.type) {
    case SET_PICKED_DATE:
      return { ...state, pickedDate: action.data };
    default:
      return state;
  }
};

const appReducer = combineReducers({
  errorReducer,
  userReducer,
  selectReducer,
  customerInfoReducer,
  staffInfoReducer,
  paymentInfoReducer,
  pickedDateReducer,
  socketReducer,
  checkOutConfirmInfoReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_REDUX) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
